import { render } from "./TeamCarousel.vue?vue&type=template&id=663883e6"
import script from "./TeamCarousel.vue?vue&type=script&lang=js"
export * from "./TeamCarousel.vue?vue&type=script&lang=js"

import "./TeamCarousel.vue?vue&type=style&index=0&id=663883e6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__